import React from 'react';

import { IPohodnikRouterItem } from '.';

const Workout = React.lazy(() => import('@apps/Workouts/Workout'));
const WorkoutEdit = React.lazy(() => import('@apps/Workouts/WorkoutEdit'));
const WorkoutGroup = React.lazy(() => import('@apps/Workouts/WorkoutGroup'));
const WorkoutNew = React.lazy(() => import('@apps/Workouts/WorkoutNew'));
const Workouts = React.lazy(() => import('@apps/Workouts/Workouts'));
const WorkoutsInvites = React.lazy(() => import('@apps/Workouts/WorkoutsInvites'));
const WorkoutsMy = React.lazy(() => import('@apps/Workouts/WorkoutsMy'));
const WorkoutMarkupPage = React.lazy(() => import('@apps/Workouts/WorkoutMarkupPage'));

const WorkoutTargetsOnePage = React.lazy(() => import('@apps/Workouts/WorkoutTargetsOnePage'));
const WorkoutTargetsListPage = React.lazy(() => import('@apps/Workouts/WorkoutTargetsListPage'));

const workoutsRoutes: Array<IPohodnikRouterItem> = [
  {
    path: '/workouts/targets',
    component: () => <WorkoutTargetsListPage />,
    protected: true,
    exact: true,
    title: 'Цели тренировок',
  },
  {
    path: '/workouts/targets/new',
    component: () => <WorkoutTargetsOnePage id_workout_target={0} />,
    protected: true,
    exact: true,
    title: 'Добавление Цели тренировок',
  },
  {
    path: '/workouts/targets/:id',
    component: ({
      match: {
        params: { id },
      },
    }) => <WorkoutTargetsOnePage id_workout_target={+id} />,
    protected: true,
    exact: true,
    title: 'Цель тренировок',
  },
  {
    path: '/workouts/invites',
    component: () => <WorkoutsInvites />,
    protected: true,
    exact: true,
    title: 'Приглашения в тренировки',
  },
  {
    path: '/workouts/new',
    component: () => <WorkoutNew />,
    protected: true,
    exact: true,
    title: 'Добавление тренировки',
  },
  {
    path: '/workouts/my',
    component: () => <WorkoutsMy />,
    protected: true,
    exact: true,
    title: 'Мои тренировки',
  },
  {
    path: '/workouts/group/:id',
    component: ({
      match: {
        params: { id },
      },
    }) => <WorkoutGroup id_group={+id} />,
    protected: false,
    title: 'Групповая тренировка',
  },
  {
    path: '/workouts/:id/markup',
    component: ({
      match: {
        params: { id },
      },
    }) => <WorkoutMarkupPage id_workout={+id} />,
    protected: true,
    title: 'Разметка тренировки',
  },
  {
    path: '/workouts/:id/edit',
    component: ({
      match: {
        params: { id },
      },
    }) => <WorkoutEdit id={+id} />,
    protected: true,
    title: 'Редактирование тренировки',
  },
  {
    path: '/workouts/:id',
    component: ({
      match: {
        params: { id },
      },
    }) => <Workout id={+id} />,
    protected: true,
    title: 'Просмотр тренировки',
  },

  {
    path: '/workouts',
    component: ({ location: { search } }) => <Workouts search={search} />,
    protected: false,
    title: 'Список всех тренировок',
  },
];

export default workoutsRoutes;
